























































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'

import User from '@/models/user'
import Membership from '@/models/membership'
import MemberPreference from '@/models/member_preference'
import Company from '@/models/company'

import Fieldset from 'primevue/fieldset'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'

Vue.component('Fieldset', Fieldset)
Vue.component('Dropdown', Dropdown)
Vue.component('Button', Button)

@Component
export default class MemberPreferencesForm extends Vue {
  @Prop() user!: User
  @Prop() member!: Membership
  @Prop() memberPreference!: MemberPreference

  companies: Company[] = []
  loading = true
  processing = false
  changesExist = false

  projectDateViewOptions = [
    'Daily',
    'Weekly',
    'Monthly'
  ]

  get projectAssigneeFilterOptions () {
    return [
      { label: this.user.fullName, value: this.user.id }
    ]
  }

  get disableSave () {
    return this.processing || !this.changesExist
  }

  @Watch('memberPreference', { deep: true })
  onMemberPreferenceChanged () {
    this.changesExist = this.memberPreference.isDirty()
  }

  async mounted () {
    await this.getCompanies()
    this.loading = false
  }

  async getCompanies () {
    this.companies = (await Company
      .order('name')
      .per(100000)
      .all()
    ).data
  }

  @Emit()
  async save () {
    this.processing = true
    await this.memberPreference.save()
    this.showSuccessMessage()
    this.processing = false
  }

  showSuccessMessage () {
    const summaryMessage = 'Preferences Updated'
    const detailMessage = 'You\'re  All Set!'
    this.$toast.add({ severity: 'success', summary: summaryMessage, detail: detailMessage, life: 3000 })
  }
}
